<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title>Assign Batch#</md-dialog-title>
        <div id="actionButton" style="margin-top: -50px; margin-left: 250px;">
            <md-button class="md-raised custButton" @click="cancelAction"><span clas="icons-center material-icons"></span>Cancel</md-button>
            <md-button id="create" class="md-raised custButton" @click="saveData"><span class="icons-center material-icons"></span>Assign</md-button>
            <!--<md-button id="create" class="md-raised custButton" @click="searchData"><span class="icons-center material-icons"></span>Search</md-button>-->
         </div> 
            <span style="width:100px; height:3px; display:''; background-color:'red'" id="undertab1"/>
            <span style="width:100px; height:3px; display:''" id="undertab2"/>
         <!--<md-progress-bar  id="pb" style="display:'none'" md-mode="indeterminate"/>-->           
         <div class="tab">
            <!--
            <md-button id="LoadOut" class="tablinks selected" @click="openTab('LoadOut')">Load Out</md-button>
            <md-button id="LoadIn" class="tablinks" @click="openTab('LoadIn')">Load In</md-button>
            -->
            <!--<md-button id="LoadIn" class="tablinks">Load In</md-button>-->
         </div>
    <!--       

  -->     
      <md-dialog-content >
        <div style="width: 600px; height: 300px">
         <form id="top" @submit.prevent="doSaveUser">
         <!--<md-progress-bar  id="pb" style="display:none" md-mode="indeterminate"/>-->
         <md-button type="submit" id="submit" style="display:none;" ></md-button> 
         <span class="info" id="status" style="display:none"></span>

         <!-- <auto-complete-stc-driver-group-select
                      label="Driver Group"
                      :options="stcDriverGroupOption"
                      v-model="batchNum"
               >
         </auto-complete-stc-driver-group-select> -->

         <div class = "inputBox">
              <md-field>
                <label>Batch Number</label>
                <md-input v-model="batchNum"/>
              </md-field>
           </div>   
           

        </form>  
       </div> 
       
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
.alwaysShow {
  position: fixed;
  right: 60px;
  top : 30px;
}

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 40px;
      font-family: Roboto Slab;
      margin-left: 44px;
}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
  }

  .tab {
      overflow: hidden;
      border: 1px solid #ccc;
      background-color: #f1f1f1;
  }

  .tab button {
      background-color: inherit;
      float: left;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 14px 16px;
      transition: 0.3s;
      /*font-size: 17px;*/
  }

  .tablinks {
     height: 50px;
  }

  .tab button:hover {
      background-color:#ddd;
      text-decoration: underline;
  }

  .tab button:active, button:focus {
      background-color: #ccc;
      text-decoration: underline;
  }

  
  .tabcontent {
      /*display: none;*/
      padding: 6px 12px;
      border: 1px solid #ccc;
      border-top: none;
  }

.info {
    background-color: #2196f3;
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    color: white;
    padding: 8px;
    height: 30px;
  }

  .result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 600px;
    padding: 10px;
    height: 43px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 100px;
   }

.result-included-inner-div {
    margin-left: 15px;
    font-weight: bold;
    /*margin-bottom: -25px;*/
    margin-top: 5px;
} 

.selected {
   text-decoration: underline;
   font-size: 14px;
   font-weight: 500;
}    

.text-divider {
  display: flex;
  align-items: center;
  --text-divider-gap: 1rem;
  font-weight:bold;
}

.text-divider::before,
.text-divider::after {
  content: '';
  height: 1px;
  background-color: silver;
  flex-grow: 1;
}

.text-divider::before {
  margin-right: var(--text-divider-gap);
}

.text-divider::after {
  margin-left: var(--text-divider-gap);
}


</style>


<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import callingApiCenter from "./CallingApiCenter.vue";
  //import api from '../api';
  import AutoCompleteStcDriverGroupSelect from '../components/AutoCompleteStcDriverGroupSelect.vue';
  import dateFormat from '../utils/dateFormat';
  import moment from 'moment';


  const initSearchDriverGroup = () => ({
     seqNo: null,
    //  driverGroup: null,
     userName: null,
     driverId: null,
     active: true,
     driverName: null,
     recWindow: null ,
     batchNum: null
  })




  export default {
    components: { 
      callingApiCenter,       
      AutoCompleteStcDriverGroupSelect,
      moment ,
    },
    mixins: [validationMixin],
    props: {
      mode: String,
      //onCreate: Function,
      onUpdate: Function,
    },
    data: () => ({
      showDialog: false,

      searchDriverGroupReq: initSearchDriverGroup(),
      //items: [],
      //selected:null,
      drivers: [],

      input_mode: null,
      // driverGroup: null,
      batchNum: null , 
      stcDriverGroupOption: []
    }),

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
        'getGSTDriverMaster',
        'getGSTDriverTruckLog',
      callingApiCenter,
      ]),
   
     
    },


    async mounted() {

          // const alldrivers = await this.$store.dispatch(
      //     'getDriversBySource',
      //     {
      //       defaultSalesOffice: 'LGB',
      //       source: 'OUTBOUND',
      //     }
      // );
      // console.log("alldrivers: " + JSON.stringify(alldrivers));
      // this.drivers = alldrivers;
      // await api.post('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
      //     this.stcDriverGroups = driverGroup;
      // })

      // //console.log("stc driver groups: " + JSON.stringify(allSTCDriverGroups)); 
      // //console.log("stc driver groups: " + this.getSTCDriverGroup); 
      // console.log("stc driver groups: " + JSON.stringify(this.stcDriverGroups))
      // //const allSTCDriverGroups = this.getSTCDriverGroup;
      // if (this.stcDriverGroups) {
      //   this.stcDriverGroups.forEach( (val) => {
      //       const p_driverGrp = this.stcDriverGroupOption.filter( it => it === val.driverGroup);
      //       console.log("p_driverGrp length: " + p_driverGrp.length);
      //       if (p_driverGrp.length == 0)
      //          this.stcDriverGroupOption.push(val.driverGroup);
      //     }
      //   )
          
      // }      
    },


    watch: {
      // getGSTDriverMaster(val) {
      //   this.updateItems(val);
      // },
      // getGSTDriverTruckLog(val) {
      //   console.log("watch method");
      //   this.updateItems(val);
      // }

      
    },


    validations: {
      // dataForm: {
      //     driver: {required},
      //     driverMobile: {required},
      //   apptInTime:{
      //       add : (value) => {
              
      //         const res = moment('2021-04-01T' + value).toDate();
      //         return res != 'Invalid Date';
      //       }
      //   },
      //   apptOutTime:{
      //       add : (value) => {
              
      //         const res = moment('2021-04-01T' + value).toDate();
      //         return res != 'Invalid Date';
      //       }
      //   },
      // },
    },



    methods: {
      async openDialog(requestdata) {
        this.$store.commit('clearApiError');
        //this.$v.dataForm.$reset();
        //console.log(this.$v.dataForm.$invalid);
        //this.dataForm = getInitialdataForm();
        console.log("update form: " + this.mode);
        console.log("request data: " + requestdata);
        console.log("mode: " + this.mode);

        this.showDialog = true;
      },

  



     cancelAction(){
        this.isdisableSend = false;
        this.isRefresh = false;
        this.showDialog = false;
        this.allowLoadInTrans = true;
        this.allowLoadOutTrans = true;
        this.smslog = [];
        this.$store.commit('clearApiError');
     },

      saveData(){

      if (this.batchNum == null || this.batchNum  == ""){
        window.confirm('Batch Number is Required!')
            return;
      };
      
      this.onUpdate(this.batchNum, this.input_mode);
      // this.onUpdate(this.batchNum, this.input_mode);
      this.showDialog = false;
   },



    },
  };


</script>